import LegacyInterceptor from '../LegacyInterceptor'
import { Provisao } from '../../../types/Provisao'

const api = new LegacyInterceptor()

export default {
  calculateValorProcedimento(procedimento = {}) {
    return api.post('/medico/producao/provisao/calculo', procedimento)
  },

  getProcedimentos(medicoId, negociacaoId) {
    return api.get(`/medico/${medicoId}/tabela-preco/${negociacaoId}/procedimento?tamanhoPagina=10000`)
  },

  getProducaoById(producaoId) {
    return api.get(`/producao/${producaoId}`)
  },

  updateProducao(producao: any) {
    return api.put(`/producao/${producao.identificador}`, producao)
  },

  saveProducao(medicoId, producao = {}) {
    return api.post(`/medico/${medicoId}/producao/provisao`, producao)
  },

  getProvisaoById(producaoId) {
    return api.get(`/medico/producao/provisao/${producaoId}`)
  },

  saveProducaoV2(provisao: Provisao) {
    return api.post(`/producao`, provisao)
  },

  getProducaoList(producao: any) {
    return api.get(`/users/current/producao?page=${producao.page}&FontePagadora=${producao.fontePagadoraId ? producao.fontePagadoraId : ''}&localexecucao=${producao.localExecucaoId ? producao.localExecucaoId : ''}&nomepaciente=${producao.pacienteId ? producao.pacienteId : ''}&profissionalexecutante=${producao.medicoId ? producao.medicoId : ''}&statuspagamento=${producao.status ? producao.status : ''}&codigoprocedimento=${producao.procedimento ? producao.procedimento : ''}&aguardandoRevisao=${producao.aguardandoRevisao ? producao.aguardandoRevisao : ''}&dataInicioRealizacao=${producao.dateStartFormatter !== undefined && producao.dateStartFormatter !== null ? producao.dateStartFormatter : ''}&dataFimRealizacao=${producao.dateEndFormatter !== undefined && producao.dateEndFormatter !== null ? producao.dateEndFormatter : ''}&MedicoProducaoId=${producao.producaoId !== undefined && producao.producaoId !== null ? producao.producaoId : ''}`)
  },

  getProducaoTotalPages(producao: any) {
    return api.get(`/users/current/producao/total-pages?page=${producao.page}&FontePagadora=${producao.fontePagadoraId ? producao.fontePagadoraId : ''}&localexecucao=${producao.localExecucaoId ? producao.localExecucaoId : ''}&nomepaciente=${producao.pacienteId ? producao.pacienteId : ''}&profissionalexecutante=${producao.medicoId ? producao.medicoId : ''}&statuspagamento=${producao.status ? producao.status : ''}&codigoprocedimento=${producao.procedimento ? producao.procedimento : ''}&aguardandoRevisao=${producao.aguardandoRevisao ? producao.aguardandoRevisao : ''}&dataInicioRealizacao=${producao.dateStartFormatter !== undefined && producao.dateStartFormatter !== null ? producao.dateStartFormatter : ''}&dataFimRealizacao=${producao.dateEndFormatter !== undefined && producao.dateEndFormatter !== null ? producao.dateEndFormatter : ''}&MedicoProducaoId=${producao.producaoId !== undefined && producao.producaoId !== null ? producao.producaoId : ''}`)
  },

  getProducaoPrint(producao: any) {
    return api.get(`/users/current/producao?page=${producao.page}&FontePagadora=${producao.fontePagadoraId ? producao.fontePagadoraId : ''}&localexecucao=${producao.localExecucaoId ? producao.localExecucaoId : ''}&nomepaciente=${producao.pacienteId ? producao.pacienteId : ''}&profissionalexecutante=${producao.medicoId ? producao.medicoId : ''}&statuspagamento=${producao.status ? producao.status : ''}&codigoprocedimento=${producao.procedimento ? producao.procedimento : ''}&aguardandoRevisao=${producao.aguardandoRevisao ? producao.aguardandoRevisao : ''}&dataInicioRealizacao=${producao.dateStartFormatter !== undefined && producao.dateStartFormatter !== null ? producao.dateStartFormatter : ''}&dataFimRealizacao=${producao.dateEndFormatter !== undefined && producao.dateEndFormatter !== null ? producao.dateEndFormatter : ''}&MedicoProducaoId=${producao.producaoId !== undefined && producao.producaoId !== null ? producao.producaoId : ''}`)
  },

  getProducaoPrintV2(producao: any) {
    return api.get(`/producao/${producao.producaoId}/imprimir`)
  },

  getFontePagadora() {
    return api.get(`/users/current/producao/fontes-pagadora`)
  },

  getLocalExecucao() {
    return api.get(`/users/current/producao/locais-execucao`)
  },

  getProducaoPacientes(producao: any) {
    return api.get(`/users/current/producao/pacientes?userId=${producao.userId}`)
  },

  getProducaoMedicos(producao: any) {
    return api.get(`/users/current/producao/profissionais-executante?userId=${producao.userId}`)
  },

  getProducaoStatus(producao: any) {
    return api.get(`/producao/status-pagamento?userId=${producao.userId}`)
  },

  getProducaoProcedimentos(producao: any) {
    return api.get(`/users/current/producao/procedimentos?userId=${producao.userId}`)
  },

  revisarProducao(producaoId: any) {
    const post = {
      MedicoProducaoId: producaoId
    }
    return api.post(`/producao/${producaoId}/revisar`, post)
  },

  removeProducao(producaoId: any) {
    return api.delete(`/producao/${producaoId}`)
  },

  getPrestadoresByUser() {
    return api.get('/users/current/contrato/fontes-pagadora')
  },

  recalcular(data: any) {
    return api.post('/calculadora/calcula-gerar-repasse-poc', data)
  },
}
